import React from 'react'
import { useDispatch } from 'react-redux'
import {
  reset,
  loadResellers,
  loadProducers,
  loadControllers
} from 'state/modules/organizers'
import { AppContainer } from '~/views/shared'
import { ProducersIndexPage } from './ProducersIndexPage'
import { InvitationIndexPage } from '../OrganizersPage/Invitations/InvitationIndexPage'
import { OrganizerControllersPage } from '../OrganizersPage/OrganizerControllersPage'
import { ControllerCreatePage } from '../OrganizersPage/OrganizerControllersPage/ControllerCreatePage'
import { OrganizerResellersPage } from '../OrganizersPage/OrganizerResellersPage'
import { ResellerCreatePage } from '../OrganizersPage/OrganizerResellersPage/ResellerCreatePage'
import { OrganizerProducersPage } from '../OrganizersPage/OrganizerProducersPage'
import { ProducerCreatePage } from '../OrganizersPage/OrganizerProducersPage/ProducerCreatePage'
import { Route, Switch } from 'react-router-dom'
import { ROUTES } from '~/views/routes'
import history from '~/config/history'

export const ProducersPage = () => {
  const dispatch = useDispatch()

  const handleSuccessfulSubmit = () => {
    history.push(ROUTES.ADMIN.PRODUCERS.INDEX)
  }

  const redirectToIndexController = async (organizerId) => {
    await dispatch(reset())
    history.push(
      ROUTES.ADMIN.ORGANIZERS.CONTROLLERS.INDEX.replace(':id', organizerId)
    )
  }

  const redirectToIndexReseller = async (organizerId) => {
    await dispatch(reset())
    history.push(
      ROUTES.ADMIN.ORGANIZERS.RESELLERS.INDEX.replace(':id', organizerId)
    )
  }

  const redirectToIndexProducer = async (organizerId) => {
    await dispatch(reset())
    history.push(
      ROUTES.ADMIN.ORGANIZERS.PRODUCERS.INDEX.replace(':id', organizerId)
    )
  }

  const onSuccessControllers = (id) => {
    dispatch(loadControllers(id))
  }

  const onSuccessResellers = (id) => {
    dispatch(loadResellers(id))
  }

  const onSuccessProducers = (id) => {
    dispatch(loadProducers(id))
  }

  return (
    <AppContainer title='Mis Productoras'>
      <Switch>
        <Route
          path={ROUTES.ADMIN.PRODUCERS.INDEX}
          component={ProducersIndexPage}
          exact
        />
        <Route
          exact
          path={ROUTES.ADMIN.ORGANIZERS.INVITATIONS}
          render={(props) => <InvitationIndexPage {...props} />}
        />
        <Route
          exact
          path={ROUTES.ADMIN.ORGANIZERS.CONTROLLERS.INDEX}
          render={(props) => (
            <OrganizerControllersPage
              {...props}
              onSuccess={onSuccessControllers}
              onBack={handleSuccessfulSubmit}
            />
          )}
        />
        <Route
          path={ROUTES.ADMIN.ORGANIZERS.CONTROLLERS.CREATE}
          render={(props) => (
            <ControllerCreatePage
              {...props}
              onSuccess={redirectToIndexController}
              onCancel={(id) => redirectToIndexController(id)}
            />
          )}
        />
        <Route
          exact
          path={ROUTES.ADMIN.ORGANIZERS.RESELLERS.INDEX}
          render={(props) => (
            <OrganizerResellersPage
              {...props}
              onSuccess={onSuccessResellers}
              onBack={handleSuccessfulSubmit}
            />
          )}
        />
        <Route
          path={ROUTES.ADMIN.ORGANIZERS.RESELLERS.CREATE}
          render={(props) => (
            <ResellerCreatePage
              {...props}
              onSuccess={redirectToIndexReseller}
              onCancel={(id) => redirectToIndexReseller(id)}
            />
          )}
        />
        <Route
          exact
          path={ROUTES.ADMIN.ORGANIZERS.PRODUCERS.INDEX}
          render={(props) => (
            <OrganizerProducersPage
              {...props}
              onSuccess={onSuccessProducers}
              onBack={handleSuccessfulSubmit}
            />
          )}
        />
        <Route
          path={ROUTES.ADMIN.ORGANIZERS.PRODUCERS.CREATE}
          render={(props) => (
            <ProducerCreatePage
              {...props}
              onSuccess={redirectToIndexProducer}
              onCancel={(id) => redirectToIndexProducer(id)}
            />
          )}
        />
      </Switch>
    </AppContainer>
  )
}

export default ProducersPage
